module.exports = __webpack_public_path__ + "media/video-corporativo-y-eventos_reel.7a27b4cf.mp4";